import { BlogPostDetailPage } from "component_old/pages/BlogPostDetailPage"
import { SEO } from "component_old/seo/SEO"
import { graphql, PageProps } from "gatsby"
import { PageContextProps } from "libs/types/PageProps"
import React from "react"

interface BlogPostBySlug {
  markdownRemark: {
    frontmatter: {
      title: string
      description: string
      date: string
      imageDescription: string
      image: {
        childImageSharp: {
          fixed: {
            src: string
          }
        }
      }
    }
    fields: {
      slug: string
    }
    html: string
  }
}

interface Props {
  data: BlogPostBySlug
}

const Page = (props: Props): JSX.Element => {
  const markdownRemark = props.data.markdownRemark

  return (
    <BlogPostDetailPage
      title={markdownRemark.frontmatter.title}
      date={markdownRemark.frontmatter.date}
      image={markdownRemark.frontmatter.image.childImageSharp.fixed.src}
      imageDescription={markdownRemark.frontmatter.imageDescription}
      htmlContent={
        <div dangerouslySetInnerHTML={{ __html: markdownRemark.html }} />
      }
    />
  )
}

export default Page

export const Head = (
  props: PageProps<BlogPostBySlug, PageContextProps>
): JSX.Element => {
  const markdownRemark = props.data.markdownRemark
  return (
    <SEO
      title={markdownRemark.frontmatter.title}
      description={markdownRemark.frontmatter.description}
      image={markdownRemark.frontmatter.image.childImageSharp.fixed.src}
      pathname={markdownRemark.fields.slug}
    />
  )
}

export const query = graphql`
  query BlogPostBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      fields {
        slug
      }
      frontmatter {
        title
        description
        imageDescription
        image {
          childImageSharp {
            fixed(width: 1000, quality: 100) {
              src
            }
          }
        }
        date(formatString: "MMMM DD, YYYY")
      }
    }
  }
`
